import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";
import { getErrorNotificationMessage } from "../../components/helper/NotificationMessage";

import api from "../../Environment";
import {
  fetchUserConfigurationsFailure,
  fetchUserConfigurationsSuccess,
  searchUserCitiesFailure,
  searchUserCitiesSuccess,
  searchUserLocationsFailure,
  searchUserLocationsSuccess,
  searchUserStatesFailure,
  searchUserStatesSuccess,
} from '../../store/actions/UserConfigurationsAction';
import { updatePayoutInfo } from '../../store/actions/PayoutAction';
import {
  FETCH_USER_CONFIGURATIONS_START,
  SEARCH_CITIES_START,
  SEARCH_LOCATIONS_START,
  SEARCH_STATES_START,
} from '../../store/actions/ActionConstant';
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";

function* fetchUserConfigurationsAPI() {
  try {
    const response = yield api.postMethod("user_configurations");
    const profileData = yield select((state) => state.users.profile.data);

    if (response.data.success) {
      yield put(hideErrorComponent());
      yield put(fetchUserConfigurationsSuccess(response.data.data));
      const profileCountry = response.data.data.countries.find(
        (c) => c.id === profileData?.country_id
      );
      yield put(
        updatePayoutInfo({
          destinationCountry: profileCountry?.code_3 ?? "USA",
        })
      );
    } else {
      yield put(fetchUserConfigurationsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchUserConfigurationsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* searchCitiesAPI() {
  try {
    const inputPayload = yield select((state) => state.userConfigurations.cities.inputData);

    const response = yield api.getMethod(`search_cities?search_key=${inputPayload?.search_key}`);
    if (response.data.success) {
      yield put(searchUserCitiesSuccess(response.data.data));
    } else {
      yield put(searchUserCitiesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(searchUserCitiesFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* searchStatesAPI() {
  try {
    const inputPayload = yield select((state) => state.userConfigurations.states.inputData);

    const response = yield api.getMethod(`search_states?search_key=${inputPayload?.search_key}`);
    if (response.data.success) {
      yield put(searchUserStatesSuccess(response.data.data));
    } else {
      yield put(searchUserStatesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(searchUserStatesFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* searchLocationsAPI() {
  try {
    const inputPayload = yield select((state) => state.userConfigurations.locations.inputData);

    const response = yield api.getMethod(`search_locations?search_key=${inputPayload?.search_key}`);
    if (response.data.success) {
      yield put(searchUserLocationsSuccess(response.data.data));
    } else {
      yield put(searchUserLocationsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(searchUserLocationsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* fetchUserConfigurationsSaga() {
  yield all([yield takeLatest(FETCH_USER_CONFIGURATIONS_START, fetchUserConfigurationsAPI)]);
  yield all([yield takeLatest(SEARCH_CITIES_START, searchCitiesAPI)]);
  yield all([yield takeLatest(SEARCH_STATES_START, searchStatesAPI)]);
  yield all([yield takeLatest(SEARCH_LOCATIONS_START, searchLocationsAPI)]);
}
